import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Landing from './Landing';

const root = ReactDOM.createRoot(document.getElementById('root'));

const path = window.location.pathname;
let RenderComponent = <App />;

if (path.startsWith('/site/')) {
  const tenantId = path.split('/')[2];
  if (tenantId) {
    RenderComponent = <Landing tenantId={tenantId} />;
  }
}

root.render(
  <React.StrictMode>
    {RenderComponent}
  </React.StrictMode>
);
